import { RS } from '../../../reducers'
import { botHostingMetadataSelector } from './botHostingMetadataSelector'

export const deployedBotVersionSelector = (state: RS) => botHostingMetadataSelector(state)?.version
